'use client';

import { useSessionTimeout } from '@/src/lib/use-session-timeout';
import { SessionTimeoutModal } from '@/src/components/ui-kontora/session-timeout-modal';
import { logoutAction } from '@/src/server/actions/logout.action';
import { useState } from 'react';

export function SessionTimeoutMonitor({ expiresAt }: { expiresAt: string }) {
  const parsedExpiry = Date.parse(expiresAt);
  const expiresAtMilliseconds = Number.isFinite(parsedExpiry) ? parsedExpiry : 0;
  const [initialTtl] = useState(() => Math.max(0, Math.ceil((expiresAtMilliseconds - Date.now()) / 1000)));
  const session = useSessionTimeout({
    totalTtlSeconds: initialTtl,
    expiresAt: expiresAtMilliseconds,
    warningThresholdSeconds: 300,
    onTimeout: () => {
      void logoutAction().catch(() => window.location.assign('/login?reason=timeout'));
    },
    onExtend: () => {
      window.location.assign('/login?reason=expiring');
    },
  });

  return (
    <SessionTimeoutModal
      isOpen={session.isWarning}
      secondsUntilTimeout={session.secondsUntilTimeout}
      onExtend={session.extend}
      onLogout={session.logout}
      requiresReauthentication
    />
  );
}
